export function getAdditionalHeaders(
    isPrivate?: boolean,
): { 'X-GEORGE-SCOPE': string } | undefined {
    return isPrivate ? { 'X-GEORGE-SCOPE': 'USER' } : undefined;
}
